import { notify } from './notify';
import { WIDGET_ERROR_MESSAGES } from './widgetErrorMessages';

export const AUTH_INVALIDATED_EVENT = 'esmart:auth-invalidated';

export const AUTH_ERROR_MESSAGE = WIDGET_ERROR_MESSAGES.token;

export const AUTH_ERROR_REASONS = [
  'missing_token',
  'malformed_token',
  'decrypt_failed',
  'invalid_format',
  'expired',
] as const;

export type AuthErrorReason = typeof AUTH_ERROR_REASONS[number];

let hasShownAuthError = false;

export const isAuthErrorReason = (
  reason: unknown,
): reason is AuthErrorReason =>
  typeof reason === 'string' &&
  AUTH_ERROR_REASONS.includes(reason as AuthErrorReason);

export const notifyAuthErrorOnce = (): void => {
  if (typeof window === 'undefined' || hasShownAuthError) return;
  hasShownAuthError = true;

  window.setTimeout(() => {
    notify({ level: 'error', message: AUTH_ERROR_MESSAGE });
  }, 0);
};

export const resetAuthErrorNotification = (): void => {
  hasShownAuthError = false;
};

export const emitAuthInvalidated = (): void => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(AUTH_INVALIDATED_EVENT));
};
